<!--大用户 - 用户管理 - 大用户规则 -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="48">
          <!-- 第一排 -->
          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="用水性质">
              <a-input v-model="query.belongingArea" placeholder="请输入用水性质" allow-clear />
            </a-form-item>
          </a-col> -->
          <!-- 第一排-操作按钮 -->
          <a-col :md="12" :sm="12" style="display: flex;">
            <div style="margin-bottom: 20px;">
              <!-- <a-button type="primary" @click="queryList">查询</a-button> -->
              <!-- <a-button style="margin-left: 12px" @click="resetList">重置</a-button> -->
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:dle>删除</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :bordered="true"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>

    <!-- modal 新增or编辑框-->
    <a-modal :title="isUpdate ? '编辑' : '新增'" :dialog-style="{ top: '240px' }" :width="600" :maskClosable="false"
      v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
      <a-form :form="addOrUpdateForm" class="tenant-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="用水性质">
          <a-select placeholder="请选择用水性质" style="width: 100%"
            v-decorator="['waterType', { rules: [{ required: true, message: '请输入用水性质' }] }]">
            <a-select-option v-for="(item, index) in waterTypeList" :key="index" :value="item.value">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="月用水量≥">
          <a-input placeholder="请输入用水量" v-decorator="['ruleValues', { rules: [{ validator: this.validateRules }] }]"
            suffix="m³" />
        </a-form-item>
        <a-form-item label="口径≥">
          <a-input placeholder="请输入口径" v-decorator="['caliberValue', { rules: [{ validator: this.validateRules }] }]"
            addon-before="DN" />
        </a-form-item>
        <a-form-item label="" :wrapperCol="{ span: 24 }">
          <div style="text-align: center">
            <a-radio-group v-decorator="['meetRules', { initialValue: 1 }]">
              <a-radio :value="1" style="margin-right: 60px;">任意满足</a-radio>
              <a-radio :value="2">同时满足</a-radio>
            </a-radio-group>
          </div>
        </a-form-item>
      </a-form>
      <div style="text-align: center; color: #c0c1c0; font-size: 12px;">
        <span>注意：“任意满足”：最少填写一个大用户规则。 “同时满足”：必须填写两个大用户规则。</span>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common' //选项式混合导入
const columns = [ //表头参数
  {
    title: '用水性质',
    dataIndex: 'waterTypeName'
  },
  {
    title: '月用水量≥(m³)',
    dataIndex: 'ruleValues'
  },
  {
    title: '口径≥',
    dataIndex: 'caliberValue'
  },
  {
    title: '满足规则',
    dataIndex: 'meetRulesName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '更改时间',
    dataIndex: 'updateTime'
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'BigUserRulesPage',
  data () {
    return {
      //needQuery: false, // 是否在created就执行查询操作
      currentId: '',
      queryUrl: '/smart-water-major-users/major/users/rules/large_user_rules/select', //查询url
      deleteUrl: '/smart-water-major-users/major/users/rules/large_user_rules/delete', //删除url
      queryOneUrl: '/smart-water-major-users/major/users/rules/large_user_rules/select',  //id编辑查询
      addOrUpdateUrl: '/smart-water-major-users/major/users/rules/large_user_rules/insert/update', //新增or编辑url
      query: { //查询对象
      },
      pagination: false,
      columns,
      value: 1, //满足规则
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      waterTypeList: [
        { value: 1, name: '居民用水' },
        { value: 2, name: '非居民用水' },
        { value: 3, name: '特种用水' },
        { value: 4, name: '其他' },
      ]
    }
  },
  methods: {
    // 重置
    resetList () {
      this.pagination.current = 1
      this.query = {}
      this.selectedRows = []
      this.queryList()
    },
    //重写重新接口
    queryList () {
      this.$http.get(this.queryUrl).then(({ data }) => {
        this.list = data
      })
    },
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http
            .delete(_this.deleteUrl, {
              data: _this.selectedRows,
            })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.queryList()
              }
            })
            .catch(() => { })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        },
      })
    },
    validateRules (_, value, callback) {

      const { getFieldValue } = this.addOrUpdateForm;
      const meetRules = getFieldValue('meetRules');
      const ruleValues = getFieldValue('ruleValues');
      const caliberValue = getFieldValue('caliberValue');
      console.log(meetRules);

      if (meetRules === 2) {
        if (!ruleValues && _.field == 'ruleValues') {
          callback('请输入用水量');
        } else if (!caliberValue && _.field == 'caliberValue') {
          callback('请输入口径');
        } else {
          callback();
        }
      } else {
        if (!ruleValues && !caliberValue) {
          callback('请输入用水量或口径');
        } else {
          callback();
        }
      }
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
